import React from 'react';
import PropTypes from 'prop-types';

/**
 * Radio component for web
 *
 * Radio button with label support
 */
const Radio = ({
  label,
  value,
  checked = false,
  onChange,
  disabled = false,
  error,
  className = '',
  id,
  name,
  ...props
}) => {
  const radioId = id || `radio-${name}-${value}`;

  return (
    <div className="flex flex-col">
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            type="radio"
            id={radioId}
            name={name}
            value={value}
            checked={checked}
            onChange={(e) => onChange?.(e.target.value)}
            disabled={disabled}
            className={[
              'radio',
              error && 'border-error-500',
              className,
            ].filter(Boolean).join(' ')}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${radioId}-error` : undefined}
            {...props}
          />
        </div>
        {label && (
          <label
            htmlFor={radioId}
            className={[
              'ml-2 text-sm font-medium select-none',
              disabled ? 'text-neutral-400 cursor-not-allowed' : 'text-neutral-700 cursor-pointer',
            ].filter(Boolean).join(' ')}
          >
            {label}
          </label>
        )}
      </div>
      {error && (
        <p id={`${radioId}-error`} className="mt-1 text-sm text-error-600">
          {error}
        </p>
      )}
    </div>
  );
};

Radio.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};

export default Radio;
